import { ApiResponse } from "../Models";

export const saveItemMockup: ApiResponse<number> = {
  statusCode: 200,
  error: null,
  data: 1212,
};
